export const getInfo = (state) => state.callStateReducer.info;
export const getMonitorState = (state) => state.callStateReducer.monitorState;
export const getCallList = (state) => state.callStateReducer.callList;
export const getCallCustomerNumber = (state) =>
  state.callStateReducer.customerNumber;
export const getCallCustomerName = (state) =>
  state.callStateReducer.customerName;
export const getCallStartTime = (state) => state.callStateReducer.startTime;
export const getCallCurrentTime = (state) => state.callStateReducer.currentTime;
// export const getTranscriptionSet = (state) =>
//   state.callStateReducer.transcription;
export const getTranscriptionSet = (state) => {
  const transcription = state.callStateReducer.transcription;
  return transcription;
};
export const getTranscriptionUpdate = (state) =>
  state.callStateReducer.transcriptionUpdate;
export const getAgentAssist = (state) => state.callStateReducer.agentAssist;
export const getSummary = (state) => {
  const summary = state.callStateReducer.summary;
  return summary;
};

export const getCallChecklist = (state) => {
  const callChecklist = state.callStateReducer.callChecklist;
  return callChecklist;
};

export const getSummaryLoading = (state) =>
  state.callStateReducer.summaryLoading;



// WEBPACK FOOTER //
// src/store/selector/call.selector.js